import { render, staticRenderFns } from "./Top10Chart.vue?vue&type=template&id=ae9bf7ec&scoped=true&"
import script from "./Top10Chart.vue?vue&type=script&lang=ts&"
export * from "./Top10Chart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9bf7ec",
  null
  
)

export default component.exports